import React from 'react';

import { ArtistSlide, ArtworkSlide, GallerySlide, ProfileSlide, ShowVertical } from '../container/Cell.jsx';
import { NoResults, Title, TitleSpaced } from '../container/Container.jsx';
import { Indicator as LoadingIndicator } from '../container/Loading.jsx';
import Carousel from './Carousel.jsx';

const sliderInstances = {};
class Artists extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: `artistsSlider-${this.props.id}`
        }

        this._handleRef = this._handleRef.bind(this);
        this.handleConfig = this.handleConfig.bind(this);
        this.handleFollowChange = this.handleFollowChange.bind(this);
        this.handleParseResponseData = this.handleParseResponseData.bind(this);

        this.slider = withConfig(Slider);
    }

    componentDidMount() {
        sliderInstances[this.state.id] = true;
    }

    componentWillUnmount() {
        sliderInstances[this.state.id] = undefined;
    }

    _handleRef(ref) {
        this.sliderRef = ref;
    }

    handleConfig() {
        if (this.props.config) {
            return this.props.config;
        }

        return {
            loop: true,
            items: 5,
            margin: 16.67,
            nav: true,
            navText: ["", ""],
            responsive: {
                // breakpoint from 0 up
                0: {
                    items: 1,
                    slideBy: 1
                },
                // breakpoint from 768 up
                768: {
                    items: 5,
                    slideBy: 5
                }
            },
            rewindNav: true
        };
    }

    handleFollowChange(d) {
        if (!this.sliderRef) {
            return;
        }
        const data = this.sliderRef.state.data;
        let artist;
        for (let i = 0; i < data.length; i++) {
            let temp = data[i];
            if (!temp || temp.ArtistId != d.ArtistId) {
                continue;
            }
            artist = temp;
            break;
        }
        if (!artist) {
            return;
        }
        const component = this;
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !component.sliderRef || !sliderInstances[component.state.id]) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            component.sliderRef.handleUpdateData(data);
        });
    }

    handleParseResponseData(responseData) {
        if (this.props.onParseResults) {
            return this.props.onParseResults(responseData);
        } else if (responseData.Artists) {
            return responseData.Artists.map(function (d) {
                Artcloud.mkt.artists._isfollowing(d);
                return d;
            });
        }
        return responseData;
    }

    render() {
        const slideProps = this.props.slideProps ? { ...this.props.slideProps } : {};
        slideProps.onFollowChange = this.handleFollowChange;

        return (
            <this.slider
                {...this.props}
                id={this.state.id}
                noResultsText="No Artists"
                ref={this._handleRef}
                slideComponent={this.props.slideComponent || ArtistSlide}
                slideProps={slideProps}
                onConfig={this.handleConfig}
                onParseResults={this.handleParseResponseData} />
        );
    }
}

class Artwork extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: `artworkSlider-${this.props.id}`
        }

        this._handleRef = this._handleRef.bind(this);
        this.handleConfig = this.handleConfig.bind(this);
        this.handleLikeChange = this.handleLikeChange.bind(this);
        this.handleParseResponseData = this.handleParseResponseData.bind(this);

        this.slider = withConfig(Slider);
    }

    componentDidMount() {
        sliderInstances[this.state.id] = true;
    }

    componentWillUnmount() {
        sliderInstances[this.state.id] = undefined;
    }

    _handleRef(ref) {
        this.sliderRef = ref;
    }

    handleConfig(data) {
        let config;
        if (this.props.config) {
            config = { ...this.props.config };
        } else {
            config = {
                autoWidth: true,
                items: 4,
                loop: true,
                margin: 16.67,
                nav: true,
                navText: ["", ""],
                rewindNav: true,
                slideBy: 4
            };
        }
        if (data.length < config.items) {
            config.loop = false;
            config.nav = false;

            if (!this.props.config) {
                config.items = data.length;
                config.slideBy = data.length;
            }
        }
        return config;
    }

    handleLikeChange(d) {
        if (!this.sliderRef) {
            return;
        }
        const data = this.sliderRef.state.data;
        let artwork;
        for (let i = 0; i < data.length; i++) {
            let temp = data[i];
            if (!temp || temp.ArtId != d.ArtId) {
                continue;
            }
            artwork = temp;
            break;
        }
        if (!artwork) {
            return;
        }
        const component = this;
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function (success) {
            if (success != true || !component.sliderRef || !sliderInstances[component.state.id]) {
                return;
            }
            artwork.IsFavorite = !artwork.IsFavorite
            component.sliderRef.handleUpdateData(data);

            if (component.props.slideProps && component.props.slideProps.onLikeChange) {
                component.props.slideProps.onLikeChange(artwork);
            }
        });
    }

    handleParseResponseData(responseData) {
        if (this.props.onParseResults) {
            return this.props.onParseResults(responseData);
        } else if (responseData.Art) {
            return responseData.Art.map(function (d) {
                Artcloud.mkt.art._isfavorite(d);
                return d;
            });
        } else if (responseData.Data) {
            return responseData.Data.map(function (d) {
                Artcloud.mkt.art._isfavorite(d);
                return d;
            });
        }
        return responseData;
    }

    render() {
        const slideProps = this.props.slideProps ? { ...this.props.slideProps } : {};
        slideProps.onLikeChange = this.handleLikeChange;
        if (!slideProps.height) {
            slideProps.height = 250;
        }
        return (
            <this.slider
                {...this.props}
                equal={false}
                id={`artworkSlider-${this.props.id}`}
                noResultsText="No Artwork"
                ref={this._handleRef}
                slideComponent={this.props.slideComponent || ArtworkSlide}
                slideProps={slideProps}
                onConfig={this.handleConfig}
                onParseResults={this.handleParseResponseData} />
        );
    }
}

class Galleries extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: `gallerySlider-${this.props.id}`
        }

        this._handleRef = this._handleRef.bind(this);
        this.handleConfig = this.handleConfig.bind(this);
        this.handleFollowChange = this.handleFollowChange.bind(this);
        this.handleParseResponseData = this.handleParseResponseData.bind(this);

        this.slider = withConfig(Slider);
    }

    componentDidMount() {
        sliderInstances[this.state.id] = true;
    }

    componentWillUnmount() {
        sliderInstances[this.state.id] = undefined;
    }

    _handleRef(ref) {
        this.sliderRef = ref;
    }

    handleConfig(data) {
        let config;
        if (this.props.config) {
            config = { ...this.props.config };
        } else {
            config = {
                items: 3,
                loop: true,
                margin: 16.67,
                nav: true,
                navText: ["", ""],
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                        slideBy: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 3,
                        slideBy: 3
                    }
                },
                rewindNav: true
            };
        }
        if (data.length < config.items) {
            config.autoWidth = false;
            config.nav = false;
        }
        return config;
    }

    handleFollowChange(d) {
        if (!this.sliderRef) {
            return;
        }
        const data = this.sliderRef.state.data;
        let gallery;
        for (let i = 0; i < data.length; i++) {
            let temp = data[i];
            if (!temp || temp.GalleryId != d.GalleryId) {
                continue;
            }
            gallery = temp;
            break;
        }
        if (!gallery) {
            return;
        }
        const component = this;
        Artcloud.mkt.galleries.updateFollowing(gallery.GalleryId, !gallery.IsFollowing, gallery.Company, function (success) {
            if (success != true || !component.sliderRef || !sliderInstances[component.state.id]) {
                return;
            }
            gallery.IsFollowing = !gallery.IsFollowing;
            component.sliderRef.handleUpdateData(data);
        });
    }

    handleParseResponseData(responseData) {
        if (this.props.onParseResults) {
            return this.props.onParseResults(responseData);
        } else if (responseData.Galleries) {
            return responseData.Galleries.map(function (d) {
                Artcloud.mkt.galleries._isfollowing(d);
                return d;
            });
        }
        return responseData;
    }

    render() {
        const slideProps = this.props.slideProps ? { ...this.props.slideProps } : {};
        slideProps.onFollowChange = this.handleFollowChange;

        return (
            <this.slider
                {...this.props}
                id={this.state.id}
                noResultsText="No Galleries"
                ref={this._handleRef}
                slideComponent={this.props.slideComponent || GallerySlide}
                slideProps={slideProps}
                onConfig={this.handleConfig}
                onParseResults={this.handleParseResponseData} />
        );
    }
}

class Profiles extends React.Component {
    constructor(props) {
        super(props);

        this.handleConfig = this.handleConfig.bind(this);
        this.handleParseResponseData = this.handleParseResponseData.bind(this);

        this.slider = withConfig(Slider);
    }

    handleConfig(data) {
        let config;
        if (this.props.config) {
            config = { ...this.props.config };
        } else {
            config = {
                items: 3,
                loop: true,
                margin: 16.67,
                nav: true,
                navText: ["", ""],
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                        slideBy: 1
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 3,
                        slideBy: 3
                    }
                },
                rewindNav: true
            };
        }
        if (data.length < config.items) {
            config.nav = false;
        }
        return config;
    }

    handleParseResponseData(responseData) {
        if (this.props.onParseResults) {
            return this.props.onParseResults(responseData);
        } else if (responseData.Profiles) {
            return responseData.Profiles;
        }
        return responseData;
    }

    render() {
        return (
            <this.slider
                {...this.props}
                id={`profilesSlider-${this.props.id}`}
                slideComponent={this.props.slideComponent || ProfileSlide}
                sliderClassName="profiles"
                onConfig={this.handleConfig}
                onParseResults={this.handleParseResponseData} />
        );
    }
}

class Shows extends React.Component {
    constructor(props) {
        super(props);

        this.handleConfig = this.handleConfig.bind(this);
        this.handleParseResponseData = this.handleParseResponseData.bind(this);

        this.slider = withConfig(Slider);
    }

    handleConfig(data) {
        let config;
        if (this.props.config) {
            config = { ...this.props.config };
        } else {
            config = {
                items: 2,
                loop: true,
                margin: 16.67,
                nav: true,
                navText: ["", ""],
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        items: 1,
                        slideBy: 1,
                        autoWidth: false
                    },
                    // breakpoint from 768 up
                    768: {
                        items: 2,
                        slideBy: 2
                    }
                },
                rewindNav: true
            };
        }
        if (data.length < config.items) {
            config.autoWidth = false;
            config.nav = false;
        }

        return config;
    }

    handleParseResponseData(responseData) {
        if (this.props.onParseResults) {
            return this.props.onParseResults(responseData);
        } else if (responseData.Shows) {
            return responseData.Shows;
        }
        return responseData;
    }

    render() {
        const slideProps = this.props.slideProps ? { ...this.props.slideProps } : {};
        slideProps.autoCenterFace = true;
        slideProps.imageClassName = 'gallery__img--cover';

        return (
            <this.slider
                {...this.props}
                hideOnEmpty={true}
                id={`showsSlider-${this.props.id}`}
                slideComponent={this.props.slideComponent || ShowVertical}
                slideProps={slideProps}
                sliderClassName="shows"
                equal={2}
                onConfig={this.handleConfig}
                onParseResults={this.handleParseResponseData} />
        );
    }
}

function Slider(props) {
    let slides;
    if (props.data && props.slideComponent) {
        slides = props.data.map((d, index) =>
            <props.slideComponent key={index} d={d} {...props.slideProps} />
        );
        if (props.hideOnEmpty && slides.length == 0) {
            return null;
        }
    }
    let className = 'container';
    if (props.className) {
        className += ` ${props.className}`;
    }

    let TitleComponent;
    if (props.title) {
        TitleComponent = props.titleSmall == true ? Title : TitleSpaced;
    }

    return (
        <div className={className}>
            {
                props.title &&
                <TitleComponent small={props.titleSmall}>
                    <h2>{props.title}</h2>
                </TitleComponent>
            }
            {props.titleContent}
            {
                !props.reload &&
                <React.Fragment>
                    <Carousel id={props.id} style={{ visibility: 'hidden', opacity: 0 }} {...props.config} noResultsText={props.noResultsText}>
                        {slides}
                    </Carousel>
                </React.Fragment>
            }
            {
                (!props.data || props.reload) &&
                <LoadingIndicator />
            }
        </div>
    );
}

function withConfig(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.state = {};

            this._configureSlider = this._configureSlider.bind(this);
            this.getData = this.getData.bind(this);
            this.handleUpdateData = this.handleUpdateData.bind(this);
        }

        componentDidMount() {
            this.getData();
        }

        componentDidUpdate(prevProps) {
            if (prevProps.q && this.props.q && JSON.stringify(prevProps.q) != JSON.stringify(this.props.q)) {
                this.setState({
                    reload: true
                }, this.getData);
            }
        }

        componentWillUnmount() {
            if (this.request) {
                this.request.abort();
                this.request = null;
            }
        }

        _configureSlider() {
            let config;
            if (this.state.data && this.state.data.length > 1 && this.props.onConfig) {
                config = this.props.onConfig(this.state.data);
            }
            const slider = document.getElementById(this.props.id);
            this.carousel = Artcloud.mkt._helpers.configureSlider(slider, config);
        }

        getData() {
            const component = this;
            const handler = function (data) {
                component.setState({
                    data,
                    reload: undefined
                }, function () {
                    setTimeout(function () {
                        component._configureSlider();
                    }, 100);
                });
            }
            if (component.props.data) {
                handler(component.props.data);
                return;
            }
            component.request = Artcloud.api.get(
                component.props.url,
                component.props.q,
                function (responseData) {
                    component.request = null;

                    let data = [];
                    if (component.props.onParseResults) {
                        data = component.props.onParseResults(responseData);
                    }
                    handler(data);
                },
                function (jqXHR, textStatus) {
                    component.request = null;
                    component.setState({
                        data: [],
                        reload: undefined
                    });
                    Artcloud.api.fail(jqXHR, textStatus);
                }
            );
        }

        handleUpdateData(data) {
            this.setState({
                data: data
            });
        }

        render() {
            return <WrappedComponent onUpdateData={this.handleUpdateData} {...this.state} {...this.props} config={this.state.data ? this.props.onConfig(this.state.data) : {}} />;
        }
    }
}

export {
    Artists,
    Artwork,
    Galleries,
    Profiles,
    Shows,
    Slider,
    withConfig
};